export default __webpack_public_path__ + "static/media/cardonzo_group.b9f9eaf8.jpg";